import {updateScroll} from '../utilities/locootiveScroll';

export default function NavTabSBuilder() {

    if ($('.v-builder__elements--tabs').length > 0) {

        const $tabs = {
            container: $('.v-builder__elements--tabs'),
            btn: $('.tabs__header--item'),
            class: {
                tabs: '.v-builder__elements--tabs',
                header: '.tabs__header--item',
                content: '.tabs__content--item',
                active: 'js-isActive'
            }
        }

        $tabs.btn.click(function () {
            const $current_slug = $(this).attr('data-tab-slug');
            const $current_header = $(this).closest($tabs.class.tabs).find($tabs.class.header);
            const $content_content = $(this).closest($tabs.class.tabs).find($tabs.class.content);

            $current_header.each(function () {
                $(this).removeClass($tabs.class.active);
            });

            $(this).addClass($tabs.class.active);

            $content_content.each(function () {
                $(this).hide(0, function () {
                    updateScroll();
                });
            })

            $(this).closest($tabs.class.tabs).find('.' + $current_slug).show(0, function () {
                updateScroll();
            });
        });
    }
}
NavTabSBuilder()
